// Extracted from App.js v0.13.0 → v1.0.0 split.
// Central helpers for backend URL, abort handling, interval options.
const _BACKEND = "https://app.vorien.in";
export const BACKEND = _BACKEND;
export const API = _BACKEND ? `${_BACKEND}/api` : "/api";

export function isAbortError(e) {
  if (!e) return false;
  const code = e.code || (e.name === "CanceledError" ? "ERR_CANCELED" : "");
  const msg = (e.message || "").toLowerCase();
  return (
    code === "ERR_CANCELED" ||
    e.name === "CanceledError" ||
    e.name === "AbortError" ||
    msg === "canceled" ||
    msg === "aborted" ||
    (e.__CANCEL__ === true)
  );
}

export function makeAbortable() {
  const ctrl = new AbortController();
  return { signal: ctrl.signal, abort: () => { try { ctrl.abort(); } catch {} } };
}

export const INTERVAL_OPTIONS = ["5m", "15m", "30m", "1h", "4h", "1d", "1wk"];
